import React, { useState, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import { StyledInput, FormErrorSectionDiv, StyledWrapper, MultiTagWrapper } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/FormComponents";
import SortableList from "components/EnsembleComponents/Common/SortableList";
import { useFetchChillerSequence } from "./useFetchAPIData";
import { MdWarning, MdClose, MdCheckCircle } from "react-icons/md";
import { BsFillXOctagonFill } from "react-icons/bs";
import { HubParamModal, FormErrorContainer, ErrorSection } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/styled";
import Spinner from "components/common/LegacySpinner";
import { SpinnerContainer } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect/styled";
import { ModelBodyDiv, HeaderTitle, FooterButtons, FooterButtonStyles } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSignCertificate/styled";
import { Button, Grid, Box, Typography } from "@material-ui/core";
import { SequenceNumber, SequenceList, ListContainer, NextSequenceList, SequenceText, InfoText, TypeContainer, SequenceItem,
  OrderContainer, SubTitle,ChillerRotateButton, FormContainer, ErrorMessageContainer, LoginError } from "./styled";
import { formErrorMessages, isDevEnvironment, getOrdinalSuffixOf } from "./constants";

const ChillerRotation = () => {
  const [state, setState] = useState({
      showModal: false,
      showLoginModal: false,
      currentSequence: [],
      nextSequence: [],
      upStreamCS: [],
      upStreamNS: [],
      downStreamCS: [],
      downStreamNS: []
    });
  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });
  const [formError, setFormError] = useState({
    username: "",
    password: ""
  });

  let url_string = window.location.href;
  url_string = url_string.replace('#/', '');
  const urlParsed = new URL(url_string);
  let equipmentId = urlParsed.searchParams.get("EquipmentId");
  equipmentId = equipmentId ? equipmentId.match(/\d/g).join("") : equipmentId; // To get only the numbers

  const { data: chillerData, error, loading, updateApiData, onSubmit, refetch: refetchChillerDetails, loginError, showSubmitAlert } =
     useFetchChillerSequence({ equipmentId });
  
  const formMetaData = [{
    label: "Username",
    id: "username",
    type: "text",
    error: formError["username"] ? formError["username"] : "",
    autoFocus: true,
    autoComplete: "new-password"
  },
  {
    label: "Password",
    id: "password",
    type: "password",
    error: formError["password"] ? formError["password"] : "",
    autoComplete: "new-password"
  }];

  useEffect(() => {
    setInitialSequenceData();
  }, [chillerData]);

  const setInitialSequenceData = () => {
    if (chillerData && chillerData.chillerPlantType === "Series Parallel") {
      if (chillerData && chillerData.currentSequence && chillerData.currentSequence.length) {
        setState(prevState => ({
          ...prevState,
          upStreamCS: getUpdatedSequenceData(chillerData.currentSequence[0].chillerInfo, true),
          downStreamCS: getUpdatedSequenceData(chillerData.currentSequence[1].chillerInfo, true),
          upStreamNS: getUpdatedSequenceData(chillerData.nextSequence[0].chillerInfo),
          downStreamNS: getUpdatedSequenceData(chillerData.nextSequence[1].chillerInfo),
        }));
      }
    } else {
      if (chillerData && chillerData.currentSequence && chillerData.currentSequence.length) {
        setState(prevState => ({
          ...prevState,
          currentSequence: getUpdatedSequenceData(chillerData.currentSequence[0].chillerInfo, true),
          nextSequence: getUpdatedSequenceData(chillerData.nextSequence[0].chillerInfo),
        }));
      }
    }
  }

  const getUpdatedSequenceData = (data, isCurrentSequence) => {
    const updatedItems = [];
    if (isCurrentSequence) {
      data.map((item) => {
        updatedItems.push({ name: item.name.join(", "), sequenceNumber: item.sequenceNumber });
        return item;
      });
    } else {
      data.map((item) => {
        updatedItems.push(getUpdatedSequenceItem(item));
        return item;
      });
    }
    return updatedItems;
  }

  const getUpdatedSequenceItem = (rawData) => {
    const name = rawData.name && rawData.name.length ? rawData.name.join(", ") : "--";
    return {
      id: `item-${rawData.sequenceNumber}`,
      rawData,
      content: <NextSequenceList><SequenceText title={name}>{name}</SequenceText >
    </NextSequenceList>
    };
  }

  const onToggleModel = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
      showLoginModal: false
    }));
  };

  const onToggleLoginModel = () => {
    if (state.showLoginModal) {
      updateApiData(prevState => ({ ...prevState, loading: false, loginError: "" }));
      setFormData(prevState => ({...prevState, username: "", password: ""}));
      setFormError(prevState => ({...prevState, username: "", password: ""}));
    }
    setState((prevState) => ({
      ...prevState,
      showModal: false,
      showLoginModal: !prevState.showLoginModal
    }));
  };

  const onDragItem = (updatedData, stateKey) => {
    const updatedItems = [];
    let sequenceNumbers = updatedData.map(item => item.rawData.sequenceNumber);
    sequenceNumbers = sequenceNumbers.sort();
    const modifiedData = Array.from(updatedData);
    modifiedData.map((item, index) => {
        const updatedRawData = {...item.rawData};
        updatedRawData.sequenceNumber = sequenceNumbers[index];
        updatedItems.push(getUpdatedSequenceItem(updatedRawData));
        return item;
      });
      setState(prevState => ({...prevState, [stateKey]: updatedItems}));
  }

  const onSubmitCallback = (status, errorObject = {}) => {
    if (status === "success") {
        window.fnChangeToViewMode && window.fnChangeToViewMode();
    }
    setState((prevState) => ({
      ...prevState,
      showLoginModal: errorObject.isLoginError ? true : false,
    }));
    if (!errorObject.isLoginError) {
      setFormData(prevState => ({...prevState, username: "", password: ""}));
    }
  };

  const getNextSequenceData = (data) => {
    const individualSequence = [];
    data.map(sequenceItem => {
      individualSequence.push(sequenceItem.rawData);
      return sequenceItem;
    });
    return individualSequence;
  }

  const onClickSubmit = () => {
    if (!formData.username || !formData.password) {
      let errorObject = {};
      ["username", "password"].map( keyValue => {
        if (!formData[keyValue]) {
          errorObject = {...errorObject, [keyValue]: formErrorMessages[keyValue]}
        }
        return keyValue;
      });
      setFormError(prevState => ({...prevState, ...errorObject}));
    } else {
      const nextSequenceData = [];
      if (chillerData && chillerData.chillerPlantType === "Series Parallel") {
        nextSequenceData.push({
          chillerInfo: getNextSequenceData(state.upStreamNS)
        });
        nextSequenceData.push({
          chillerInfo: getNextSequenceData(state.downStreamNS)
        });
      } else {
        nextSequenceData.push({
          chillerInfo: getNextSequenceData(state.nextSequence)
        });
      }
      const payload = { 
          "chillerPlantType": chillerData.chillerPlantType,
          "nextSequence": nextSequenceData,
          "equipmentId": Number(equipmentId),
          "username": formData["username"],
          "password": formData["password"]
      };
      onSubmit(payload, onSubmitCallback);
    }
  }

  const onClickApply = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: false,
      showLoginModal: true
    }));
  }

  const onChangeForm = useCallback((id, value) => {
    setFormData(prevState => ({...prevState, [id]: value}));
    if (state.showLoginModal && loginError) {
      updateApiData(prevState => ({...prevState, loginError: ""}));
    }
    if (!value) {
      setFormError(prevState => ({...prevState, [id]: formErrorMessages[id] ? formErrorMessages[id] : "Field should not be empty"}));
    } else {
      setFormError(prevState => ({...prevState, [id]: ""}));
    }
  }, [state.showLoginModal, loginError]);

  const onKeyDownInForm =  useCallback((id, keyCode) => {
    if (id && keyCode === "Enter") {
      onClickSubmit();
    }
  }, [onClickSubmit]);

  const getTracerLoginComponent = () => {
    return (
      <ModelBodyDiv>
        <HeaderTitle id="header-title">
            <Box onClick={onToggleLoginModel}><MdClose /></Box>
            <Box component="label">Tracer SC Login</Box>
        </HeaderTitle>
        <ErrorMessageContainer>
          {
            loginError ? <LoginError>
              <MdWarning /> <Box component="p">{loginError}</Box>
            </LoginError> : null
          }
        </ErrorMessageContainer>
        <FormContainer>
          {
            formMetaData.map(componentProps => {
              return (<Box>
                <Typography>{componentProps.label}</Typography>
                <StyledWrapper>
                  <MultiTagWrapper>
                    <StyledInput
                      {...componentProps}
                      onChange={(event) => onChangeForm(componentProps.id, event.target.value, event)}
                      onKeyDown={(event) => onKeyDownInForm(componentProps.id, event.code, event)}
                    />
                    {componentProps.error ? <FormErrorSectionDiv><BsFillXOctagonFill /><p>{componentProps.error}</p></ FormErrorSectionDiv> : null}
                  </MultiTagWrapper>
                </StyledWrapper>
              </Box>)
            })
          }
        </FormContainer>
        <FooterButtons id="model-footer-section">
            <FooterButtonStyles>
              <Button  id="cancel_button" variant="contained" onClick={onToggleLoginModel}>Cancel</Button>
              <Button id="apply_button" variant="contained" onClick={onClickSubmit}>Ok</Button>
            </FooterButtonStyles>
        </FooterButtons>
      </ModelBodyDiv>
    );
  }

  const getSequenceComponent = (keyValue, data, chillerPlantType) => {
    if (chillerPlantType === "Series Parallel") {
      if (keyValue === "current") {
        const { upStreamCS, downStreamCS } = state;
        return (<Grid container>
          <Grid item sm={6} xs={12}>
              <SubTitle>Up Stream Group</SubTitle>
              {
                upStreamCS && upStreamCS.length ? upStreamCS.map(item => (<SequenceList>
                  <SequenceNumber>{getOrdinalSuffixOf(Number(item.sequenceNumber))}</SequenceNumber><SequenceItem component="p" title={item.name}>{item.name}</SequenceItem>
                </SequenceList>)) : <Typography component="label">No data available</Typography>
              }
          </Grid>
          <Grid item sm={6} xs={12}>
              <SubTitle>Down Stream Group</SubTitle>
              {
                downStreamCS && downStreamCS.length ? downStreamCS.map(item => (<SequenceList>
                  <SequenceNumber>{getOrdinalSuffixOf(Number(item.sequenceNumber))}</SequenceNumber><SequenceItem component="p" title={item.name}>{item.name}</SequenceItem>
                </SequenceList>)) : <Typography component="label">No data available</Typography>
              }
          </Grid>
        </Grid>);
      } else {
        const { upStreamNS, downStreamNS } = state;
        return (<Grid container>
          <Grid item sm={6} xs={12}>
              <SubTitle mb={1}>Up Stream Group</SubTitle>
              {
                upStreamNS && upStreamNS.length ? <SortableList 
                    items={upStreamNS}
                    onSortChange={(data) => onDragItem(data, "upStreamNS")}
                    width="260px"
                    height="33px"
                  /> : 
                <Typography component="label">No data available</Typography>
              }
          </Grid>
          <Grid item sm={6} xs={12}>
              <SubTitle>Down Stream Group</SubTitle>
              {
                downStreamNS && downStreamNS.length ? <SortableList
                    items={downStreamNS}
                    onSortChange={(data) => onDragItem(data, "downStreamNS")}
                    width="260px"
                    height="33px"
                  /> : 
                  <Typography component="label">No data available</Typography>
              }
          </Grid>
        </Grid>);
      }
    } else {
      if (keyValue === "current") {
        return data && data.length ? data.map(item => (<SequenceList>
              <SequenceNumber>{getOrdinalSuffixOf(Number(item.sequenceNumber))}</SequenceNumber><SequenceItem component="p" title={item.name}>{item.name}</SequenceItem>
            </SequenceList>)) : <Typography component="label">No data available</Typography>;
      } else {
        return data && data.length ? <SortableList
            items={data}
            onSortChange={(data) => onDragItem(data, "nextSequence")}
            width="260px"
            height="33px"
          /> : <Typography component="label">No data available</Typography>;
      }
    }
  }

  const getModalBodyComponents = () => {
    return <ModelBodyDiv>
    <HeaderTitle id="header-title">
        <div onClick={onToggleModel}><MdClose /></div>
        <label>Rotate Chiller Sequence</label>
    </HeaderTitle>
    <div id="chiller-rotation-contents">
      <Grid container>
        <InfoText item xs={12}>
          <Box component="p" >Drag and drop the item to change the rotation order. Tracer SC login credential are required to update the sequence.</Box>
        </InfoText>
        <TypeContainer item xs={12}>
            <Box>
              <Box textAlign="center" component="label">Base Chiller:</Box>
              <Box textAlign="center" component="p">
                {chillerData && chillerData.sequenceType && chillerData.sequenceType.baseChiller ? chillerData.sequenceType.baseChiller : "--" }
              </Box>
            </Box>
            <Box>
              <Box textAlign="center" component="label">Swing Chiller:</Box>
              <Box textAlign="center" component="p">
                {chillerData && chillerData.sequenceType && chillerData.sequenceType.swingChiller ? chillerData.sequenceType.swingChiller : "--" }
              </Box>
            </Box>
              <Box>
                <Box textAlign="center" component="label">Peak Chiller:</Box>
                <Box textAlign="center" component="p">
                  {chillerData && chillerData.sequenceType && chillerData.sequenceType.peakChiller ? chillerData.sequenceType.peakChiller : "--" }
                </Box>
              </Box>
              <Box>
                <Box textAlign="center" component="label">Pony Chiller:</Box>
                <Box textAlign="center" component="p">
                  {chillerData && chillerData.sequenceType && chillerData.sequenceType.ponyChiller ? chillerData.sequenceType.ponyChiller : "--" }
                </Box>
              </Box>
        </TypeContainer>
        <OrderContainer container>
          <Grid item xs={12} sm={6}>
            <Box component="h5">Current Sequence</Box>
            <ListContainer>
              {
                getSequenceComponent("current", state.currentSequence, chillerData.chillerPlantType)
              }
            </ListContainer>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box component="h5">Next Sequence</Box>
            <ListContainer>
              {
                getSequenceComponent("next", state.nextSequence, chillerData.chillerPlantType)
              }
            </ListContainer>
          </Grid>
        </OrderContainer>
      </Grid>
    </div>
    <FooterButtons id="model-footer-section">
        <FooterButtonStyles>
          <Button  id="cancel_button" variant="contained" onClick={onToggleModel}>Cancel</Button>
          <Button id="apply_button" variant="contained" onClick={onClickApply}>Apply</Button>
        </FooterButtonStyles>
    </FooterButtons>
    </ModelBodyDiv>
  }

  const onClickChillerRotate = () => {
    refetchChillerDetails();
    setState((prevState) => ({
      ...prevState,
      showModal: true,
    }));
  }
  
  const getRenderComponents = () => {
    return (
      <div>
        <ChillerRotateButton onClick={onClickChillerRotate} variant="contained" disableRipple >
          Rotate Chillers
        </ChillerRotateButton>
        <HubParamModal
          isOpen={state.showModal}
          toggle={onToggleModel}
          id="rotate-chiller-model"
          maxWidth={chillerData && chillerData.chillerPlantType === "Series Parallel" ? "77%" : "43%"}
          mt="6%"
        >
          {
            getModalBodyComponents()
          }
        </HubParamModal>
        <HubParamModal
          isOpen={state.showLoginModal}
          toggle={onToggleLoginModel}
          id="tracer-login-model"
          maxWidth="30%"
          mt="8%"
        >
          {
            getTracerLoginComponent()
          }
        </HubParamModal>
        {
            error ? <ErrorSection left="8%" type={showSubmitAlert}>
              <FormErrorContainer type={showSubmitAlert}>
                {
                  showSubmitAlert === "success" ? <MdCheckCircle /> : <MdWarning />
                }
                {
                  showSubmitAlert === "error" ? <Box>
                    <b>Chiller sequence failed to update.</b>
                    <p>{error}</p>
                  </Box>: <b>{error}</b>
                }
              </FormErrorContainer>
              <div>
                  <MdClose onClick={() => updateApiData(prevState => ({ ...prevState, error: "", showSubmitAlert: "" }))}/>
              </div>
            </ErrorSection> : null
        }
        { loading ? <SpinnerContainer width="100%" top="5%" left="0%">
                        <Spinner />
                    </SpinnerContainer> : null
                }
      </div>
    );
  };

  return !isDevEnvironment
    ? ReactDOM.createPortal(
        getRenderComponents(),
        document.getElementById("chiller-rotation-portal")
      )
    : getRenderComponents();
};

export default ChillerRotation;
